import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { ComponentProps, forwardRef } from 'react'

type RoundSearchBarProps = ComponentProps<'input'> & {
  value: string
  onClear: () => void
}
const RoundSearchBar = forwardRef<HTMLInputElement, RoundSearchBarProps>(
  ({ value, onClear, ...rest }: RoundSearchBarProps, ref) => {
    return (
      <div className="relative flex w-full transition-all focus-within:z-10 sm:max-w-[600px]">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4">
          <MagnifyingGlassIcon className="h-6 w-6 text-zinc-600" aria-hidden="true" />
        </div>
        <input
          value={value}
          className="block w-full rounded-full border-0 py-3 px-12 text-sm leading-6 text-zinc-900 ring-1 ring-inset ring-zinc-300 transition-all placeholder:text-zinc-500 focus:ring-2 focus:ring-inset focus:ring-blue-600"
          ref={ref}
          {...rest}
        />
        <div className="absolute inset-y-0 right-0 flex items-center pr-4">
          {value.length > 0 && (
            <XMarkIcon
              className="h-6 w-6 text-zinc-600 hover:cursor-pointer hover:stroke-zinc-600"
              aria-hidden="true"
              onClick={() => onClear()}
            />
          )}
        </div>
      </div>
    )
  }
)

RoundSearchBar.displayName = 'RoundSearchBar'

export default RoundSearchBar
